
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7166/api/',
    //Live

    //DEV
    apiUrl: 'https://tt-api.solegaze.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;

